<template>
	<div>
		<h3>Платежи по договору займа можно внести любым из перечисленных способов:</h3>
		<ul>
			<li>
				<a 
					target="_blank"
					href="https://finmoll.ru/backend/content/documents/certificate_ooo_finmoll"
					class=txtLink
					>Свидетельство ООО МКК «ФИНМОЛЛ»</a>
			</li>
			<li>
				<a 
				target="_blank" 
				href="https://finmoll.ru/backend/content/documents/certificate_sro_mir" 
				class=txtLink>Свидетельство членства СРО МИР</a>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	name: 'txtEvidence',
}
</script>

<style scoped>
h3{margin-bottom: var(--font-size-15);font-size: var(--font-size-18);}
a.txtLink {margin-bottom: var(--font-size-10);}
</style>